import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FIELD_RADIO_NONE, FIELD_TYPE } from 'Component/Field/Field.config';
import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    ProductContainer as SourceProductContainer
} from 'SourceComponent/Product/Product.container';
import { hideActiveOverlay } from 'Store/Overlay/Overlay.action';
import { showPopup } from 'Store/Popup/Popup.action';
import getFieldsData from 'Util/Form/Extract';
import { getNewParameters, getVariantIndex } from 'Util/Product';
import getStore from 'Util/Store';
import { validateGroup } from 'Util/Validator';

/** @namespace Elganso/Component/Product/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
    // TODO extend mapDispatchToProps
});

/** @namespace Elganso/Component/Product/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
    // TODO extend mapStateToProps
});

/** @namespace Elganso/Component/Product/Container */
export class ProductContainer extends SourceProductContainer {
    static propTypes = {
        ...this.PropTypes,
        preorder: PropTypes.number
    };

    containerFunctions = {
        ...this.containerFunctions,
        onChangeColor: this.onChangeColor.bind(this),
        onSuscribeOutOfStock: this.onSuscribeOutOfStock.bind(this),
        handleOutOfStockClick: this.handleOutOfStockClick.bind(this)
    };

    containerProps() {
        const {
            product: {
                preorder
            }
        } = this.props;

        return {
            ...super.containerProps(),
            preorder
        };
    }

    componentDidMount() {
        const { product = {} } = this.props;
        super.componentDidMount();

        if (this.props?.product?.attributes?.color && this.props?.product?.attributes?.default_color?.attribute_value && !this.state?.parameters?.color) {
            let product_colors = null;

            if (product.configurable_options.color) {
                product_colors = Object.keys(product.configurable_options.color.attribute_options);
            } else {
                product_colors = Object.keys(product.attributes.color.attribute_options);
            }

            // COMPROBAR PARAMETRO COLOR CORRESPONDE A UNO DE LOS COLORES DEL PRODUCTO
            if (product_colors.find((e) => e === this.props?.product?.attributes?.default_color?.attribute_value)) {
                this.updateConfigurableVariant('color', this.props.product.attributes.default_color.attribute_value, true);
            } else {
                this.updateConfigurableVariant('color', product_colors[0], true);
            }
        }
    }

    onChangeColor(nombre, imagen, preorder = 0, preRebaja, attribute_value = null, description = null) {
        this.props.product.name = nombre;
        this.props.product.preorder = preorder;

        this.props.product.yeboyebo_carrito_promociones_fecha_hasta = preRebaja.yeboyebo_carrito_promociones_fecha_hasta;
        this.props.product.yeboyebo_carrito_promociones_precio = preRebaja.yeboyebo_carrito_promociones_precio;

        if (description !== null) {
            this.props.product.description = description;
        }

        if (imagen?.attribute_value) {
            this.props.product.image.path = imagen.attribute_value;
            this.props.product.image.url = `${this.props.product.image.url.split('product')['0']}product${imagen.attribute_value}`;
        }

        // CAMBIAMOS EL COLOR ACTUAL PARA HACER EL CAMBIO DE LAS TALLAS PARA MOSTRAR LOS SOBRES DE SIN STOCK
        if (attribute_value) {
            this.props.product.attributes.color.attribute_value = attribute_value;
            this.props.product.configurable_options.color.attribute_value = attribute_value;
        }

        this.setState({ });
    }

    onSuscribeOutOfStock() {
        const store = getStore();
        const { dispatch } = store;
        dispatch(showPopup(`outofstock-popup-${this.props.product.sku}`, { title: __('Pop up fuera de stock') }));
    }

    updateSelectedValues(data = {}) {
        const { configFormRef: { current } = {}, product: { id } } = this.props;
        const idFormulario = `form-id-${ id}`;
        const enteredOptions = [];
        const selectedOptions = [];
        const { uid, value } = data;
        const formularioCustomizable = document.getElementById(idFormulario);

        if (!current) {
            return;
        }

        if (uid && value) {
            enteredOptions.push({
                uid,
                value
            });
        }

        let values = getFieldsData(current, true, [FIELD_TYPE.numberWithControls]);
        if (id !== undefined && formularioCustomizable) {
            values = getFieldsData(formularioCustomizable, true, [FIELD_TYPE.numberWithControls]);
        }

        values.forEach(({
            field, name, value, type
        }) => {
            if (type === FIELD_TYPE.select) {
                selectedOptions.push(value);
            } else if (type === FIELD_TYPE.checkbox || type === FIELD_TYPE.radio) {
                if (value !== FIELD_RADIO_NONE) {
                    selectedOptions.push(value);
                }
            } else if (type !== FIELD_TYPE.numberWithControls && type !== FIELD_TYPE.file) {
                enteredOptions.push({
                    uid: name,
                    value
                });
            } else if (type === FIELD_TYPE.file && field.value) {
                enteredOptions.push({
                    uid: name,
                    value
                });
            }
        });

        this.setState({
            enteredOptions,
            selectedOptions
        });
    }

    /**
     * Updates configurable products selected variant
     * @param key
     * @param value
     */
    updateConfigurableVariant(key, value, checkEmptyValue = false, addToCartCatalog = false, selectFichaProducto = false) {
        const { parameters: prevParameters } = this.state;
        const { product: { variants, configurable_options }, product } = this.props;
        const { selectedProduct } = this.state;

        const newParameters = getNewParameters(prevParameters, key, value);

        const { [key]: oldValue, ...currentParameters } = newParameters;
        let parameters = oldValue === '' && checkEmptyValue ? currentParameters : newParameters;

        // CAMBIAMOS LA FUNCIONALIDAD EN LUGAR DE QUE LA LONGITUD DE LAS OPCIONES CONFIGURABLES
        // DEL PRODUCTO SEAN IGUAL A LA LONGITUD DE LOS PARAMETROS PASADOS, COMPROBAMOS QUE LAS
        // OPCIONES CONFIGURABLES ESTEN DENTRO DE LOS PARAMETROS

        // const newIndex = Object.keys(parameters).length === Object.keys(configurable_options).length
        //     ? getVariantIndex(variants, parameters)
        //     // Not all parameters are selected yet, therefore variantIndex must be invalid
        //     : -1;

        const areConfOptInParam = (arr, target) => target.every((v) => arr.includes(v));
        if (addToCartCatalog && product && product.configurable_options !== undefined) {
            if (product !== undefined && product.configurable_options?.size !== undefined && product.configurable_options?.color === undefined && parameters.color !== undefined) {
                parameters = { size: parameters.size };
            }
        }

        this.setState({ parameters });

        const newIndex = areConfOptInParam(Object.keys(parameters), Object.keys(configurable_options))
            ? getVariantIndex(variants, parameters)
            : -1;
        const newProduct = newIndex === -1 ? null : variants[newIndex];

        if (newProduct !== selectedProduct) {
            if (newProduct?.stock_status === 'OUT_OF_STOCK' || (newProduct?.stock_status == null && newProduct?.stock_item?.in_stock === false)) {
                if (selectFichaProducto) {
                    this.setState({
                        selectedProduct: newProduct,
                        parameters
                    });
                }
            } else if (addToCartCatalog) {
                this.setState({
                    selectedProduct: newProduct,
                    parameters
                }, () => {
                    this.setState({ isAddingToCart: true });
                    this.addToCart();
                });
            } else {
                this.setState({
                    selectedProduct: newProduct,
                    parameters
                });
            }
        }
    }

    /**
     * Event that validates and invokes product adding into cart
     * @returns {*}
     */
    async addToCart() {
        this.updateSelectedValues();
        const { showError, product } = this.props;

        if (this.hasError()) {
            return;
        }

        const { addProductToCart, cartId } = this.props;
        const products = this.getMagentoProduct();
        if (product !== undefined && product.configurable_options?.size !== undefined && product.configurable_options?.color === undefined && products[0].selected_options?.length === 2) {
            products[0].selected_options = [products[0].selected_options[1]];
        }

        await addProductToCart({ products, cartId })
            .then(
                /** @namespace Elganso/Component/Product/Container/ProductContainer/addToCart/then/catch/addProductToCart/then */
                () => {
                    this.setState({ isAddingToCart: false });
                }
            ).catch(
                /** @namespace Elganso/Component/Product/Container/ProductContainer/addToCart/then/catch */
                (error) => {
                    if (error) {
                        showError(error);
                        this.setState({ isAddingToCart: false });
                    }
                }
            );

        this.showPopupProductoAsociado();

        if (this.props.mix) {
            const {
                mix: {
                    block
                }
            } = this.props;

            const store = getStore();
            const { dispatch } = store;

            if (block === 'ProductoAsociado') {
                dispatch(hideActiveOverlay());
            }
        }
    }

    /**
     * checks if product has errors before adding to cart
     * @returns {boolean}
    */
    hasError() {
        const { errorMessages, errorFields, values } = validateGroup(this.validator);
        const { product: { configurable_options = null, type_id }, showError } = this.props;
        const {
            parameters: {
                color = null,
                size = null
            }
        } = this.state;

        if (
            errorFields
            || errorMessages
            || this.validateConfigurableProduct()
            || this.filterAddToCartFileErrors(values)
        ) {
            this.scrollOptionsIntoView();
            this.setState({ addToCartTriggeredWithError: true });

            if (type_id !== 'simple') {
                if (configurable_options.color !== undefined && color == null && configurable_options.size !== undefined && size == null) {
                    showError(__('Please select a size and color of the product!'));
                } else if (configurable_options.color !== undefined && color == null) {
                    showError(__('Please select a color of the product!'));
                } else if (configurable_options.size !== undefined && size == null) {
                    showError(__('Please select a size of the product!'));
                } else {
                    showError(__('Incorrect or missing options!'));
                }
            } else {
                showError(__('Incorrect or missing options!'));
            }

            return true;
        }

        return false;
    }

    handleOutOfStockClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const { product } = this.props;

        const store = getStore();
        const { dispatch } = store;
        dispatch(showPopup(`outofstock-popup-${product.sku}`, {
            title: __('Pop up fuera de stock'), product, productClicked: product, isOutOfStock: 1
        }));
    }

    showPopupProductoAsociado() {
        const {
            product: {
                sku,
                producto_asociado
            }
        } = this.props;

        if (producto_asociado) {
            const store = getStore();
            const { dispatch } = store;
            dispatch(showPopup(`producto-asociado-${sku}`, {
                title: 'PRODUCTO ASOCIADO'
            }));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductContainer);
